import { gql } from '@apollo/client';

export const COMPONENT_LIST_PATCH = gql`
    mutation patchComponentList( $input: PatchComponentListInput! ) {
        result: patchComponentList( input: $input ) {
            componentListId
            type
            uuids
        }
    }
`;

export default COMPONENT_LIST_PATCH;
